import React, { useState } from 'react'
import ExhibitorProfileLink from '../../../lib/components/ExhibitorProfileLink'
import { useInRouterContext, useLocation } from 'react-router-dom'
import { byTheme } from '../../functions/exhibitorViews'
import { LABELS } from '../../constants/staticText'
import { Ueberschrift } from '../../../lib/a11y/Ueberschrift'

// Verweise von der Ausstellerkarte kommen als /…/themen/#beruf-<id> herein.
// Zugeklappt waere der Beruf am Ziel unsichtbar, darum bestimmt der Anker, welche
// Kategorie offen ist (#53).
const professionAnchor = 'beruf-'

const groupOfAnchor = (groups, hash) => {
    const professionId = hash.replace(`#${professionAnchor}`, '')
    const group = groups.find(g => g.professions.some(p => professionId === p.id))
    return group ? group.id : ''
}

// Akkordeon je Berufskategorie; Namen und Reihenfolge kommen aus themeCategories
// derselben Antwort (Spec Abschnitt 6.1).
//
// Der Anker bestimmt nur den Anfangszustand — danach klickt der Nutzer. Auf der
// Kachelseite kommt er aus dem Router, im Shortcode (#177) gibt es keinen:
// dort liest ihn das Fenster. Zwei Einstiege, ein Akkordeon.
const RoutedTheme = (props) => <ThemeGroups hash={useLocation().hash} {...props} />

const ProfessionsByTheme = (props) => useInRouterContext()
    ? <RoutedTheme {...props} />
    : <ThemeGroups hash={window.location.hash} {...props} />

const ThemeGroups = ({ data, hash }) => {
    const groups = byTheme(data)
    // Alle Gruppen zugeklappt wie auf der Live-Seite: die Liste der Kategorien
    // ist die Übersicht, geöffnet wird eine nach Wahl (#19). Führt ein Verweis
    // auf einen Beruf, ist dessen Kategorie von Anfang an offen (#53).
    const [openId, setOpenId] = useState(() => hash.startsWith(`#${professionAnchor}`)
        ? groupOfAnchor(groups, hash)
        : '')

    if (0 === groups.length) return <p className="section-empty">{LABELS.noProfessions}</p>

    return (
        <div className="section-themes">
            {groups.map(group => (
                <section key={group.id} className={`theme-group ${group.id === openId ? 'is-open' : ''}`}>
                    <Ueberschrift className="theme-group-title">
                        <button
                            type="button"
                            id={`themen-knopf-${group.id}`}
                            aria-expanded={group.id === openId}
                            // Nur solange das Panel im Dokument steht (#236).
                            aria-controls={group.id === openId ? `themen-panel-${group.id}` : undefined}
                            onClick={() => setOpenId(group.id === openId ? '' : group.id)}
                        >
                            {group.name}
                            <span className="theme-group-indicator" aria-hidden="true" />
                        </button>
                    </Ueberschrift>
                    {/* Knopf und Panel sind verbunden (aria-controls, #178); das Panel
                        ist eine benannte Region um die Liste — auf dem <ul> nahm die
                        Rolle ihm die Listenrolle (#236). */}
                    {group.id === openId && (
                        <div
                            id={`themen-panel-${group.id}`}
                            role="region"
                            aria-labelledby={`themen-knopf-${group.id}`}
                        >
                            <ul className="theme-professions">
                                {group.professions.map(profession => (
                                    <li key={profession.id} id={`${professionAnchor}${profession.id}`}>
                                        <strong>{profession.title}</strong>
                                        <ul>
                                            {profession.exhibitors.map(e => <li key={e.participantId}><ExhibitorProfileLink id={e.participantId}>{e.name}</ExhibitorProfileLink></li>)}
                                        </ul>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}
                </section>
            ))}
        </div>
    )
}

export default ProfessionsByTheme
